import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { QRCodeComponent } from 'angularx-qrcode';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './shared/components/nav-menu/nav-menu.component';
import { HomeComponent } from './modules/home/home.component';
import { GameComponent } from './modules/game/components/game/game.component';
import { JoinGameComponent } from './modules/game/components/join-game/join-game.component';
import { CardsComponent } from './modules/game/components/cards/cards.component';
import { CardComponent } from './modules/game/components/cards/card/card.component';
import { TableComponent } from './modules/game/components/table/table.component';
import { PlayerComponent } from './modules/game/components/table/player/player.component';
import { ConfigureGameComponent } from './modules/game/components/configure-game/configure-game.component';
import { PlayerProfileComponent } from './shared/components/nav-menu/player-profile/player-profile.component';
import { VoteResultComponent } from './modules/game/components/vote-result/vote-result.component';
import { TopBarComponent } from './modules/game/components/game/top-bar/top-bar.component';
import { BottomBarComponent } from './modules/game/components/game/bottom-bar/bottom-bar.component';

import { GameFoundGuard } from './modules/game/guards/game-found.guard';
import { JoinGameGuard } from './modules/game/guards/join-game-guard';
import { UrlConstants } from './shared/constants/urlparams.constants';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    GameComponent,
    CardsComponent,
    CardComponent,
    JoinGameComponent,
    TableComponent,
    ConfigureGameComponent,
    PlayerComponent,
    PlayerProfileComponent,
    VoteResultComponent,
    TopBarComponent,
    BottomBarComponent,
    QRCodeComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    NgbModule,
    ToastrModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'game/:' + UrlConstants.GameID, redirectTo: '/', pathMatch: 'full' },
      {
        path: 'game/:' + UrlConstants.GameID + '/configure',
        component: ConfigureGameComponent,
        canActivate: [GameFoundGuard],
        pathMatch: 'full'
      },
      {
        path: 'game/:' + UrlConstants.GameID + '/:' + UrlConstants.GameName,
        component: GameComponent,
        canActivate: [JoinGameGuard],
        pathMatch: 'full'
      },
      {
        path: 'game/:' + UrlConstants.GameID + '/:' + UrlConstants.GameName + '/joinGame',
        component: JoinGameComponent,
        pathMatch: 'full',
        canActivate: [GameFoundGuard]
      }
    ])
  ],
  entryComponents: [],
  providers: [GameFoundGuard, JoinGameGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
